import React from 'react';
import ReactEcharts from 'echarts-for-react';
import 'echarts/lib/chart/pie';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';
import { useTheme } from '../../../../theme-context';

interface IPieData {
    name: string;
    value: number;
}

interface IPieChart {
    data: IPieData[];
}

const PieChart = ({ data }: IPieChart) => {
    const { theme } = useTheme();

    const getOption = () => ({
        color: theme === 'dark' ? ['#dCdCdC', '#95A4FC', '#BAEDBD', '#B1E3FF', '#fff'] :['#1C1C1C', '#95A4FC', '#BAEDBD', '#B1E3FF', '#252B37'],
        legend: {
            show: true,
            orient: 'vertical',
            right: 10,
            top: 'middle',
            icon: 'circle',
            itemWidth: 10,
            itemHeight: 10,
            itemGap: 16,
            textStyle: {
                color: theme === 'dark' ? '#fff' : '#000',
                fontSize: 14
            },
            formatter: (name: string) => {
                const item = data.find(d => d.name === name);
                const percentage = item
                    ? ((item.value / data.reduce((sum, d) => sum + d.value, 0)) * 100).toFixed(1)
                    : '0';
                return `${name}    ${percentage}%`;
            }
        },

        tooltip: {
            trigger: 'item',
            formatter: '{b}: {d}%'
        },
        series: [
            {
                type: 'pie',
                radius: ['20%', '35%'],
                center: ['20%', '50%'],
                label: { show: false },
                labelLine: { show: false },
                data,
            }
        ]

    });

    return (
        <ReactEcharts option={getOption()} style={{ height: 400, width: '100%' }} />
    );
};

export default PieChart;